(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[268],{

/***/ 42207:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/categoria/[categorySlug]/[page]",
      function () {
        return __webpack_require__(65964);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 65964:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ Categorys; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/components/seo.tsx
var seo = __webpack_require__(39425);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(98788);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(47842);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(45680);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/GlobalStyles/GlobalStyles.js
var GlobalStyles = __webpack_require__(51039);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/styled.js
var styled = __webpack_require__(13264);
// EXTERNAL MODULE: ./node_modules/@apollo/client/react/hooks/useQuery.js + 2 modules
var useQuery = __webpack_require__(6812);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/graphql-tag/lib/index.js + 9 modules
var lib = __webpack_require__(57800);
;// CONCATENATED MODULE: ./src/queries/category/getCategoryProducts.ts
/*
 * File: getCategoryProducts.ts
 * Project: meki
 * File Created: Monday, 3rd May 2021 2:55:03 pm
 * Author: Esperanza Horn (esperanza@inventures.cl)
 * -----
 * Last Modified: Thursday, 29th December 2022 3:33:55 pm
 * Modified By: Gabriel Ulloa (gabriel@inventures.cl)
 * -----
 * Copyright 2020 - 2021 Incrementa Ventures SpA. ALL RIGHTS RESERVED
 * Terms and conditions defined in license.txt
 * -----
 * Inventures - www.inventures.cl
 */ 
function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query getCategoryProducts(\n    $params: BestSellingProductsCategoryParams!\n    $categoryParams: GetCategoryParams!\n  ) {\n    bestSellingProductsCategory(params: $params) {\n      pageInfo {\n        totalPages\n        pageNumber\n      }\n      nodes {\n        id\n        uuid\n        slug\n        name\n        price\n        concentration\n        unit\n        quantity\n        package\n        composition\n        display\n        containerQuantity\n        container\n        isMedicine\n        availability {\n          status\n        }\n        categories {\n          id\n          name\n          slug\n        }\n        imagesUrl\n        activePrinciple\n        laboratory\n        isCheapestActivePrinciple\n        discount {\n          price\n          listPrice\n          type\n          stockRestriction\n          dateRestriction\n        }\n      }\n      brands {\n        brand\n        quantity\n      }\n    }\n\n    category(params: $categoryParams) {\n      id\n      name\n      slug\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var getCategoryProducts = function() {
    return (0,lib/* gql */.Ps)(_templateObject());
};

// EXTERNAL MODULE: ./src/utils/index.ts + 3 modules
var utils = __webpack_require__(8881);
// EXTERNAL MODULE: ./src/components/CategoriesBreadcrumbs.tsx
var CategoriesBreadcrumbs = __webpack_require__(52138);
// EXTERNAL MODULE: ./src/components/SearchContentContainer.tsx
var SearchContentContainer = __webpack_require__(99760);
// EXTERNAL MODULE: ./src/components/ProductFilterOptions.tsx
var ProductFilterOptions = __webpack_require__(11215);
// EXTERNAL MODULE: ./src/components/ProductsNotFound.tsx
var ProductsNotFound = __webpack_require__(98137);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./src/components/Product/index.tsx + 5 modules
var Product = __webpack_require__(77616);
// EXTERNAL MODULE: ./src/hooks/useBottomReach.ts
var useBottomReach = __webpack_require__(11514);
// EXTERNAL MODULE: ./src/components/Header/Header.tsx
var Header = __webpack_require__(23722);
;// CONCATENATED MODULE: ./src/screens/category/index.tsx





















var ProductDrawer = dynamic_default()(function() {
    var promise = Promise.all(/* import() */[__webpack_require__.e(4567), __webpack_require__.e(8199), __webpack_require__.e(969)]).then(__webpack_require__.bind(__webpack_require__, 50969)).then(function(mod) {
        return mod.ProductDrawer;
    });
    return promise;
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(50969)
            ];
        }
    }
});
var backgroundGlobalStyle = /*#__PURE__*/ (0,jsx_runtime.jsx)(GlobalStyles/* default */.Z, {
    styles: {
        body: {
            backgroundColor: "#f9f9f9 !important"
        }
    }
});
var HeaderContainer = (0,styled/* default */.Z)("div")(function(param) {
    var theme = param.theme;
    var _obj;
    return _obj = {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        padding: "8px 12px 0 12px",
        gap: 10
    }, (0,_define_property/* default */.Z)(_obj, theme.breakpoints.up(700), {
        flexDirection: "row",
        justifyContent: "space-between",
        paddingTop: 8
    }), (0,_define_property/* default */.Z)(_obj, theme.breakpoints.up(1230), {
        maxWidth: 1200,
        margin: "auto"
    }), _obj;
});
function CategoryIndex(props) {
    var ref, ref1, ref2, ref3, ref4, ref5;
    // Hooks init:
    var router = (0,next_router.useRouter)();
    var ref6 = (0,react.useState)(false), toggleDrawer = ref6[0], setToggleDrawer = ref6[1];
    var ref7 = (0,react.useState)(false), navigating = ref7[0], setNavigating = ref7[1];
    var ref8 = (0,react.useState)(0), totalFiltersCheck = ref8[0], setTotalFiltersCheck = ref8[1];
    // Queries:
    var queryParams = (0,react.useMemo)(function() {
        var brands = router.query.brands ? router.query.brands.split(",") : undefined;
        var priceRanges = router.query.priceRanges ? [
            router.query.priceRanges
        ].flat().map(function(priceRange) {
            var queryObject = Object.fromEntries(priceRange.split(";").map(function(range) {
                return range.split(":");
            }));
            return {
                start: +(queryObject === null || queryObject === void 0 ? void 0 : queryObject.start) ? +queryObject.start : undefined,
                stop: +(queryObject === null || queryObject === void 0 ? void 0 : queryObject.stop) ? +queryObject.stop : undefined
            };
        }) : undefined;
        return {
            brands: brands,
            priceRanges: priceRanges
        };
    }, [
        router.query
    ]);
    var variables = (0,react.useMemo)(function() {
        return {
            params: {
                pageNumber: 1,
                slug: router.query.categorySlug,
                filterBy: {
                    brands: queryParams.brands,
                    priceRanges: queryParams.priceRanges
                },
                sortBy: {
                    price: router.query.sortBy == "price" ? true : false,
                    alphabetically: router.query.sortBy == "alphabetically" ? true : false,
                    mostSelling: router.query.sortBy == "mostSelling" ? true : false
                }
            },
            categoryParams: {
                slug: router.query.categorySlug
            }
        };
    }, [
        queryParams.brands,
        queryParams.priceRanges,
        router.query.categorySlug,
        router.query.sortBy, 
    ]);
    var ref9 = (0,useQuery/* useQuery */.aM)(getCategoryProducts(), {
        variables: variables,
        skip: !router.query.categorySlug,
        fetchPolicy: "cache-and-network"
    }), freshData = ref9.data, loading = ref9.loading, fetchMore = ref9.fetchMore;
    var data = freshData || props.initialData;
    var categoryData = data === null || data === void 0 ? void 0 : data.category;
    var handleFetchMore = (0,react.useMemo)(function() {
        var ref, ref1;
        var _pageNumber;
        if ((data === null || data === void 0 ? void 0 : (ref = data.bestSellingProductsCategory) === null || ref === void 0 ? void 0 : ref.pageInfo.totalPages) <= ((_pageNumber = data === null || data === void 0 ? void 0 : (ref1 = data.bestSellingProductsCategory) === null || ref1 === void 0 ? void 0 : ref1.pageInfo.pageNumber) !== null && _pageNumber !== void 0 ? _pageNumber : 1)) {
            return;
        }
        return /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
            var ref, _pageNumber;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            fetchMore({
                                variables: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, variables), {
                                    params: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, variables.params), {
                                        pageNumber: ((_pageNumber = data === null || data === void 0 ? void 0 : (ref = data.bestSellingProductsCategory) === null || ref === void 0 ? void 0 : ref.pageInfo.pageNumber) !== null && _pageNumber !== void 0 ? _pageNumber : 1) + 1
                                    })
                                })
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
    }, [
        data === null || data === void 0 ? void 0 : (ref = data.bestSellingProductsCategory) === null || ref === void 0 ? void 0 : ref.pageInfo.totalPages,
        data === null || data === void 0 ? void 0 : (ref1 = data.bestSellingProductsCategory) === null || ref1 === void 0 ? void 0 : ref1.pageInfo.pageNumber,
        fetchMore,
        variables, 
    ]);
    var ref10 = (0,useBottomReach/* useBottomReach */.U)(handleFetchMore), loadingMore = ref10.loading;
    var handleToggleDrawer = (0,react.useCallback)(function(event) {
        if (event && event.type === "keydown" && (event.key === "Tab" || event.key === "Shift")) {
            return;
        }
        setToggleDrawer(!toggleDrawer);
    }, [
        toggleDrawer
    ]);
    var handleSort = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(type) {
            var newRoute;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        newRoute = function() {
                            return {
                                pathname: router.pathname,
                                query: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, router.query), {
                                    sortBy: type
                                })
                            };
                        };
                        setNavigating(true);
                        return [
                            4,
                            router.push(newRoute())
                        ];
                    case 1:
                        _state.sent();
                        setNavigating(false);
                        return [
                            2
                        ];
                }
            });
        });
        return function(type) {
            return _ref.apply(this, arguments);
        };
    }(), [
        router
    ]);
    var handleTotalFiltersChecked = (0,react.useCallback)(function(total) {
        setTotalFiltersCheck(total);
    }, []);
    var handleCleanFilter = (0,react.useCallback)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var newRoute;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    newRoute = function() {
                        return {
                            pathname: router.pathname,
                            query: (0,utils/* removeUndefineds */.ox)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, router.query), {
                                brands: undefined,
                                priceRanges: undefined,
                                sortBy: router.query.sortBy
                            }))
                        };
                    };
                    setNavigating(true);
                    return [
                        4,
                        router.push(newRoute())
                    ];
                case 1:
                    _state.sent();
                    setNavigating(false);
                    return [
                        2
                    ];
            }
        });
    }), [
        router
    ]);
    var ref11;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            backgroundGlobalStyle,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Header/* Header */.h, {
                hasSearchBox: true
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(SearchContentContainer/* SearchContentContainer */.I, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(HeaderContainer, {
                        children: [
                            router.query.categorySlug && /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoriesBreadcrumbs/* CategoriesBreadcrumbs */._, {
                                categorySlug: router.query.categorySlug
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductFilterOptions/* ProductFilterOptions */.z, {
                                totalFiltersCheck: totalFiltersCheck,
                                handleToggleDrawer: handleToggleDrawer,
                                handleSort: handleSort,
                                sortType: router.query.sortBy
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            children: [
                                (data === null || data === void 0 ? void 0 : data.bestSellingProductsCategory) && /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductDrawer, {
                                    handleToggleDrawer: handleToggleDrawer,
                                    toggleDrawer: toggleDrawer,
                                    data: data === null || data === void 0 ? void 0 : data.bestSellingProductsCategory,
                                    handleTotalFiltersChecked: handleTotalFiltersChecked,
                                    setNavigating: setNavigating
                                }),
                                (data === null || data === void 0 ? void 0 : (ref2 = data.bestSellingProductsCategory) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.nodes) === null || ref3 === void 0 ? void 0 : ref3.length) > 0 || loading || navigating ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Product/* Products */.Q, {
                                    title: categoryData === null || categoryData === void 0 ? void 0 : categoryData.name,
                                    data: navigating ? [] : (ref11 = data === null || data === void 0 ? void 0 : (ref4 = data.bestSellingProductsCategory) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.nodes) === null || ref5 === void 0 ? void 0 : ref5.map(function(product) {
                                        return {
                                            product: product
                                        };
                                    })) !== null && ref11 !== void 0 ? ref11 : [],
                                    loading: loading || loadingMore || navigating
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductsNotFound/* ProductsNotFound */._, {
                                    onClick: handleCleanFilter
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
}

;// CONCATENATED MODULE: ./pages/categoria/[categorySlug]/[page].tsx
/*
 * File: [page].tsx
 * Project: meki
 * File Created: Friday, 11th June 2021 8:03:17 pm
 * Author: Gabriel Ulloa (gabriel@inventures.cl)
 * -----
 * Last Modified: Monday, 27th November 2023 5:50:39 pm
 * Modified By: Blanca Munizaga (blanca@inventures.cl)
 * -----
 * Copyright 2019 - 2021 Incrementa Ventures SpA. ALL RIGHTS RESERVED
 * Terms and conditions defined in license.txt
 * -----
 * Inventures - www.inventures.cl
 */ 



var __N_SSG = true;
function Categorys(param) {
    var data = param.data;
    var ref, ref1;
    var router = (0,next_router.useRouter)();
    var ref2;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(seo/* SEOHead */.R, {
                title: "Meki \xb7 ".concat(/reciente/.exec(router.query.categorySlug) ? "Productos Recientes" : /destacados/.exec(router.query.categorySlug) ? "Destacados" : (ref2 = (ref1 = (ref = data === null || data === void 0 ? void 0 : data.bestSellingProductsCategory.nodes[0]) === null || ref === void 0 ? void 0 : ref.categories.find(function(category) {
                    return category.slug == router.query.categorySlug;
                })) === null || ref1 === void 0 ? void 0 : ref1.name) !== null && ref2 !== void 0 ? ref2 : "", " \xb7 ").concat(router.query.page)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoryIndex, {
                initialData: data
            })
        ]
    });
}


/***/ }),

/***/ 52138:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ CategoriesBreadcrumbs; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(64489);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(68346);
/* harmony import */ var _mui_system__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(13264);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8881);
/* harmony import */ var _mui_icons_material_NavigateNext__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(37958);
/* harmony import */ var _utils_strings__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(92918);






var StyledBreadcrumbs = (0,_mui_system__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
    display: "flex",
    alignItems: "center",
    overflow: "hidden",
    maxWidth: "100%",
    "& .MuiBreadcrumbs-separator": {
        marginLeft: "2px",
        marginRight: "2px",
        flexShrink: 0
    },
    "& .MuiBreadcrumbs-ol": {
        flexWrap: "nowrap",
        overflow: "hidden",
        display: "flex",
        alignItems: "center"
    },
    "& .MuiBreadcrumbs-li": {
        flexShrink: 0,
        display: "flex",
        alignItems: "center",
        "&:last-child": {
            flexShrink: 1,
            minWidth: 0,
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            display: "flex",
            alignItems: "center",
            "& a": {
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                maxWidth: "100%",
                display: "inline-block"
            }
        }
    }
});
var StyledLink = (0,_mui_system__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
    fontSize: "12px",
    fontFamily: "Poppins",
    display: "inline-block"
});
function CategoriesBreadcrumbs(param) {
    var categorySlug = param.categorySlug, subCategorySlug = param.subCategorySlug;
    if (!categorySlug) {
        return null;
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(StyledBreadcrumbs, {
        separator: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_icons_material_NavigateNext__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
            sx: {
                fontSize: "0.875rem"
            }
        }),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledLink, {
                href: (0,_utils__WEBPACK_IMPORTED_MODULE_1__/* .getRoute */ .Bv)("home").toString(),
                color: "text.secondary",
                underline: "hover",
                children: "P\xe1gina de inicio"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledLink, {
                href: (0,_utils__WEBPACK_IMPORTED_MODULE_1__/* .getRoute */ .Bv)("subCategories", {
                    categorySlug: categorySlug
                }).toString(),
                color: subCategorySlug ? "text.secondary" : "text.primary",
                underline: "hover",
                children: (0,_utils_strings__WEBPACK_IMPORTED_MODULE_6__/* .capitalizeWord */ .ZX)(categorySlug)
            }),
            subCategorySlug && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledLink, {
                href: (0,_utils__WEBPACK_IMPORTED_MODULE_1__/* .getRoute */ .Bv)("subCategory", {
                    categorySlug: categorySlug,
                    subCategorySlug: subCategorySlug,
                    page: "1",
                    sortBy: "mostSelling"
                }).toString(),
                color: "text.primary",
                underline: "hover",
                children: (0,_utils_strings__WEBPACK_IMPORTED_MODULE_6__/* .capitalizeWord */ .ZX)(subCategorySlug)
            })
        ]
    });
}


/***/ }),

/***/ 11215:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "z": function() { return /* binding */ ProductFilterOptions; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(66383);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(54481);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(73812);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(31538);
/* harmony import */ var _mui_material_Fade__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(9942);
/* harmony import */ var _mui_icons_material_ImportExportOutlined__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(81688);
/* harmony import */ var _mui_icons_material_Tune__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(75395);
/* harmony import */ var _mui_system__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(13264);
/*
 * File: ProductFilterOptions.tsx
 * Project: meki
 * File Created: Wednesday, 11th August 2021 6:35:45 pm
 * Author: Luis Aparicio (luis@inventures.cl)
 * -----
 * Last Modified: Monday, 27th November 2023 5:22:10 pm
 * Modified By: Blanca Munizaga (blanca@inventures.cl)
 * -----
 * Copyright 2019 - 2021 Incrementa Ventures SpA. ALL RIGHTS RESERVED
 * Terms and conditions defined in license.txt
 * -----
 * Inventures - www.inventures.cl
 */ 

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  gap: 11px;\n  justify-content: center;\n  margin: 0 12px;\n  ",
        " {\n    justify-content: flex-end;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  background-color: white;\n  color: #0a7abe;\n  text-transform: unset;\n  padding: 6px 26px;\n  border-radius: 100px;\n  border: 1px solid #f0f0f0;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  min-width: 150px;\n  font-family: 'Poppins';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}







var ButtonGroup = (0,_mui_system__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)("div")(_templateObject(), function(props) {
    return props.theme.breakpoints.up(700);
});
var Button = (0,_mui_system__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)("button")(_templateObject1());
function ProductFilterOptions(props) {
    var handleToggleDrawer = props.handleToggleDrawer, totalFiltersCheck = props.totalFiltersCheck, handleSort = props.handleSort, sortType = props.sortType;
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(react__WEBPACK_IMPORTED_MODULE_2__.useState(null), 2), anchorEl = ref[0], setAnchorEl = ref[1];
    var handleClick = function(event) {
        setAnchorEl(event.currentTarget);
    };
    var handleClose = function() {
        setAnchorEl(null);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(ButtonGroup, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Button, {
                onClick: handleToggleDrawer,
                children: [
                    "Filtrar",
                    " ",
                    totalFiltersCheck > 0 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                        badgeContent: totalFiltersCheck,
                        color: "primary"
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_icons_material_Tune__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {})
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Button, {
                onClick: handleClick,
                children: [
                    "Ordenar",
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_icons_material_ImportExportOutlined__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {})
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                id: "simple-menu",
                anchorEl: anchorEl,
                keepMounted: true,
                open: Boolean(anchorEl),
                onClose: handleClose,
                anchorOrigin: {
                    vertical: "bottom",
                    horizontal: "center"
                },
                transformOrigin: {
                    vertical: "top",
                    horizontal: "center"
                },
                TransitionComponent: _mui_material_Fade__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z,
                variant: "selectedMenu",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                        onClick: function() {
                            handleClose();
                            handleSort("mostSelling");
                        },
                        // component={'button'}
                        selected: sortType === "mostSelling",
                        children: "M\xe1s vendidos"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                        onClick: function() {
                            handleClose();
                            handleSort("price");
                        },
                        selected: sortType === "price",
                        children: "Precio"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                        onClick: function() {
                            handleClose();
                            handleSort("alphabetically");
                        },
                        selected: sortType === "alphabetically",
                        children: "A - Z"
                    })
                ]
            })
        ]
    });
}


/***/ }),

/***/ 98137:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ ProductsNotFound; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26993);
/* harmony import */ var _mui_material_Typography__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(29630);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _mui_system__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(13264);
/*
 * File: ProductsNotFound.tsx
 * Project: meki
 * File Created: Thursday, 12th August 2021 9:45:49 am
 * Author: Luis Aparicio (luis@inventures.cl)
 * -----
 * Last Modified: Thursday, 16th November 2023 3:39:12 pm
 * Modified By: Blanca Munizaga (blanca@inventures.cl)
 * -----
 * Copyright 2019 - 2021 Incrementa Ventures SpA. ALL RIGHTS RESERVED
 * Terms and conditions defined in license.txt
 * -----
 * Inventures - www.inventures.cl
 */ 





var NotFound = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
    var promise = __webpack_require__.e(/* import() */ 6598).then(__webpack_require__.bind(__webpack_require__, 16598)).then(function(mod) {
        return mod.NotFound;
    });
    return promise;
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(16598)
            ];
        }
    }
});
var DivText = (0,_mui_system__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)("div")({
    flexGrow: 1,
    paddingTop: 20,
    textAlign: "center",
    justifyContent: "center",
    alignItems: "center",
    "@media (min-width: 1024px)": {
        paddingTop: "10%"
    }
});
var MiddleTextTypography = (0,_mui_system__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_mui_material_Typography__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
    padding: "10px 0"
});
function ProductsNotFound(params) {
    var onClick = params.onClick;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(DivText, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Typography__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                variant: "h6",
                color: "textPrimary",
                children: "No encontramos lo que buscas"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(MiddleTextTypography, {
                variant: "body2",
                color: "textPrimary",
                children: "Intenta con otro filtro o limpiandolos"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                color: "primary",
                variant: "contained",
                size: "large",
                onClick: onClick,
                children: "LIMPIAR FILTROS"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(NotFound, {})
            })
        ]
    });
}


/***/ }),

/***/ 39425:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ SEOHead; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(96670);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(50930);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_seo__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2962);
/* harmony import */ var _siteMetaData_json__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(64507);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _config_environment__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(60031);










var BASE_IMAGES = [
    {
        url: "https://d1zphfo9y2yvu9.cloudfront.net/meta/Meki.jpg",
        type: "image/jpg",
        width: 1200,
        height: 630
    },
    {
        url: "https://d1zphfo9y2yvu9.cloudfront.net/meta/1200x630.png",
        type: "image/png",
        width: 1200,
        height: 630
    },
    {
        url: "https://d1zphfo9y2yvu9.cloudfront.net/meta/256x256.jpg",
        type: "image/jpg",
        width: 256,
        height: 256
    },
    {
        url: "https://d1zphfo9y2yvu9.cloudfront.net/meta/256x256.png",
        type: "image/png",
        width: 256,
        height: 256
    }, 
];
function SEOHead(props) {
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_5__.useRouter)();
    var description = props.description, title = props.title, customImage = props.customImage, canonical = props.canonical;
    var site = _siteMetaData_json__WEBPACK_IMPORTED_MODULE_4__/* .landing */ ._;
    var image = customImage;
    var metaDescription = description ? description : site.description;
    var metaTitle = title || site.title;
    var headData = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
        title: metaTitle,
        description: metaDescription
    }, canonical ? {
        canonical: canonical
    } : {});
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_3__/* .NextSeo */ .PB, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, headData), {
                openGraph: {
                    title: metaTitle,
                    description: metaDescription,
                    type: site.type,
                    url: "".concat(_config_environment__WEBPACK_IMPORTED_MODULE_6__/* .BASE_URL */ ._n).concat(router.asPath),
                    images: [
                        image && {
                            url: image.url,
                            width: Number(image.width.replace("px", "")),
                            height: Number(image.height.replace("px", "")),
                            alt: metaTitle
                        }, 
                    ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(BASE_IMAGES)).filter(Boolean)
                },
                additionalMetaTags: [
                    {
                        name: "viewport",
                        content: site.scale
                    }
                ]
            })),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    charSet: site.charSet
                })
            })
        ]
    });
}


/***/ }),

/***/ 64507:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"_":{"title":"Meki · Farmacia a domicilio","description":"Todo lo que necesitas, hasta los medicamentos difíciles. Precios bajos y convenio con Cenabast. Despacho GRATIS en Santiago por compras sobre $35.000.","author":"@mimeki","type":"website","charSet":"utf-8","scale":"width=device-width, initial-scale=1","image":{"url":"https://meki-public.s3.us-east-2.amazonaws.com/meta/Meki.jpg","type":"image/jpg","width":"1200","height":"630"},"imageCart":{"url":"https://meki-public.s3.us-east-2.amazonaws.com/meta/metadataCarrito.png","type":"image/png","width":"256","height":"256"}}}');

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2962,4241,9774,2888,179], function() { return __webpack_exec__(54961), __webpack_exec__(42207); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);